//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Hint from '~/components/other/Hint'

export default {
  components: {
    Hint,
  },
  data() {
    return {
      hint: null,
      hintsText: {}
    }
  },
  methods: {
    async handleMouseMove(e) {
     this.hint = `Став патроном, вы: <br> <br>
                      - впишете свое имя рядом с шедевром; <br>
                      - начнете или продолжите формировать свою личную коллекцию; <br>
                      - поможете из года в год приобретать новые работы и внесете вклад в развитие традиций меценатства. <br>
      `
    }
  },
}
